/* eslint react/jsx-filename-extension: "off" */
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import axios from 'axios';
import reducers from './reducers';
import { ClientApp } from './containers/index';
import './semantic/semantic.min.css';

import registerServiceWorker from './registerServiceWorker';
import './index.css';

const store = createStore(reducers, {
  resources: [],
  tags: [],
  tagGroups: [],
  queries: undefined,
  resourceSearchText: '',
  suggestions: [],
  view: 'home',
  resourceEditor: {
    open: false,
    resource: undefined,
    isNew: undefined,
  },
  tagEditor: null,
  groupEditor: null,
  sortBy: 'views',
  mode: 'client',
});

Promise.all([
  axios.get('https://gp-web01.bu.edu/api/resources'),
  axios.get('https://gp-web01.bu.edu/api/tags'),
  axios.get('https://gp-web01.bu.edu/api/tag-groups'),
]).then(([resources, tags, tagGroups]) => {
  store.dispatch({
    type: 'INITIAL_SETUP',
    resources: resources.data,
    tags: tags.data,
    tagGroups: tagGroups.data,
  });
});

render(
  <Provider store={store}>
    <ClientApp />
  </Provider>,
  document.getElementById('root'),
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js